import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
import { IconCodeEmum, Iconfont } from '@src/components'
import { Modal, PickerView } from 'antd-mobile'

let timeStampStepperValue = 0
let startTimeStamp = 0
let endTimeStamp = 0
let resultDays = []
let resultHours = []
let resultMinutes = []

// 弹框-日期时间选择
class GLModalCoupons extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		tip: PropTypes.string,
		value: PropTypes.array,
		startBookTime: PropTypes.number,
		endBookTime: PropTypes.number,
		interval: PropTypes.number,
		commit: PropTypes.func,
		close: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		title: '请选择预约时间',
		tip: '',
		value: [],
		startBookTime: 0, // 开始时间戳
		endBookTime: 0, // 结束时间戳
		interval: 10, // 分钟间隔
		commit: () => {},
		close: () => {},
	}

	constructor(props) {
		super(props)
		this.state = {
			value: [],
			days: [],
			hours: [],
			minutes: [],
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		console.log('componentDidUpdate', prevProps)
		console.log('componentDidUpdate', prevState)
		if (prevProps.isShow !== this.props.isShow && this.props.isShow === true) {
			// 初始化
			this.getIndexArrayByDate()
		}
	}

	timeChange = (value) => {
		console.log(value)

		resultDays = this.getDays()
		let indexDay = 0
		resultDays.map((item, index) => {
			if (item.value === value[0]) {
				indexDay = index
			}
		})
		let indexHour = 0
		resultHours = this.getHours(indexDay)
		resultHours.map((item, index) => {
			if (item.value === value[1]) {
				indexHour = index
			}
		})
		resultMinutes = this.getMinutes(indexDay, indexHour)

		const self = this
		this.setState(
			{
				days: resultDays,
				hours: resultHours,
				minutes: resultMinutes,
			},
			function() {
				self.setState({
					value,
				})
			},
		)
	}

	timeCommit() {
		console.log(this.state.value)
		this.props.commit(this.state.value)
	}

	getIndexArrayByDate() {
		const minTimeStamp = this.props.startBookTime
		const maxTimeStamp = this.props.endBookTime
		const interval = this.props.interval
		if (minTimeStamp > maxTimeStamp) return []
		timeStampStepperValue = interval * 60 * 1000
		startTimeStamp = Math.ceil(minTimeStamp / timeStampStepperValue) * timeStampStepperValue
		endTimeStamp = Math.floor(maxTimeStamp / timeStampStepperValue) * timeStampStepperValue

		let value = this.props.value
		if (this.props.value.length < 3) {
			let initDate = new Date()
			let date = new Date(this.props.startBookTime)
			// 如果当前时间不在取值范围,就取第一个时间
			if (initDate.getTime() >= startTimeStamp && initDate.getTime() <= endTimeStamp) {
				date = initDate
			}
			let day = _.format(date, 'yyyy-MM-dd')
			let hour = date.getHours()
			let minute = date.getMinutes()
			// 如果不是整分钟，那就加一分钟
			if (date.getTime() % 60000 !== 0) {
				minute++
			}
			minute = Math.ceil(minute / interval) * interval
			if (minute > 60 - interval) {
				hour += 1
				minute = 0
			}
			if (hour >= 24) {
				day = _.format(new Date(date.getTime() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd')
				hour = 0
			}
			value = [day, hour, minute]
		}

		resultDays = this.getDays()
		let indexDay = 0
		resultDays.map((item, index) => {
			if (item.value === value[0]) {
				indexDay = index
			}
		})
		let indexHour = 0
		resultHours = this.getHours(indexDay)
		resultHours.map((item, index) => {
			if (item.value === value[1]) {
				indexHour = index
			}
		})
		resultMinutes = this.getMinutes(indexDay, indexHour)

		const self = this
		this.setState(
			{
				days: resultDays,
				hours: resultHours,
				minutes: resultMinutes,
			},
			function() {
				self.setState({
					value,
				})
			},
		)
	}

	/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ 工具 */
	getDays() {
		// 天数设置
		const oneDayTimeStamp = 24 * 60 * 60 * 1000
		const days = []
		for (
			let timeStamp = startTimeStamp;
			timeStamp <= endTimeStamp;
			timeStamp += oneDayTimeStamp
		) {
			let str = _.format(new Date(timeStamp), 'yyyy-MM-dd')
			let dict = {
				label: str,
				value: str,
			}
			days.push(dict)
		}
		// 判断是否夸天
		let dict = days[days.length - 1]
		let str = dict['value'] + ' 23:59:59'
		const lastDay = new Date(str.replace(/-/g, '/'))
		if (lastDay.getTime() + timeStampStepperValue < endTimeStamp) {
			let str = _.format(new Date(lastDay.getTime() + timeStampStepperValue), 'yyyy-MM-dd')
			let dict = {
				label: str,
				value: str,
			}
			days.push(dict)
		}
		return days
	}

	getHours(indexDay) {
		const interval = this.props.interval
		const dayDict = resultDays[indexDay]
		const day = dayDict['value']

		// 小时设置
		const hours = []
		for (let i = 0; i < 24; i++) {
			let hour = i
			for (let j = 0; j < 60; ) {
				let minute = j
				let str = day + ' ' + hour + ':' + minute + ':00'
				const hourTimeStamp = new Date(str.replace(/-/g, '/')).getTime()
				if (hourTimeStamp >= startTimeStamp && hourTimeStamp <= endTimeStamp) {
					let dict = {
						label: hour + '点',
						value: hour,
					}
					hours.push(dict)
					break
				}
				j += interval
			}
		}
		return hours
	}

	getMinutes(indexDay, indexHour) {
		const interval = this.props.interval
		const dayDict = resultDays[indexDay]
		const hourDict = resultHours[indexHour]
		const day = dayDict['value']
		const hour = hourDict['value']

		// 分钟设置
		const minutes = []
		for (let i = 0; i < 60; ) {
			let minute = i
			let str = day + ' ' + hour + ':' + minute + ':00'
			const minuteTimeStamp = new Date(str.replace(/-/g, '/')).getTime()
			if (minuteTimeStamp >= startTimeStamp && minuteTimeStamp <= endTimeStamp) {
				let dict = {
					label: minute + '分',
					value: minute,
				}
				minutes.push(dict)
			}
			i += interval
		}
		return minutes
	}

	render() {
		let { isShow, title, tip, close } = this.props
		let { days, hours, minutes } = this.state

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modal}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<div className={CSS.modalContainer}>
					<div className={CSS.modalClose}>
						<p className={CSS.modalCloseTitle}>{title}</p>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{
								fontSize: '0.32rem',
								lineHeight: '0.4rem',
								color: 'rgb(216, 216, 216)',
								position: 'absolute',
								top: 0,
								right: '.4rem',
							}}
							onPress={close.bind(this)}
						/>
					</div>
					{_.isHasValue(tip) ? (
						<div className={CSS.tip}>
							<p>{tip}</p>
						</div>
					) : null}
					<div className={CSS.modalContent}>
						<PickerView
							onChange={this.timeChange}
							value={this.state.value}
							data={[days, hours, minutes]}
							cascade={false}
							itemStyle={{
								fontSize: '.32rem',
								color: '#222',
								height: '.9rem',
								lineHeight: '.9rem',
							}}
							indicatorStyle={{ height: '.9rem' }}
							prefixCls='pickerView'
						/>
					</div>
					<p className={CSS.modalCommit} onClick={this.timeCommit.bind(this)}>
						确定
					</p>
				</div>
			</Modal>
		)
	}
}

export default GLModalCoupons
